/* eslint-disable react/prop-types */
import React from "react";
import { Box, Icon, IconButton } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { ErrorMessage, Field } from "formik";
import { useLocation, useParams } from "react-router-dom";

export default function FileField({ name, ...rest }) {
  return <Field name={name} component={FileComp} {...rest} />;
}

function FileComp(props) {
  const {
    label,
    error,
    success,
    form: { setFieldValue, ...formRest },
    field: { name, value: file, onBlur },
  } = props;

  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const disabled = id && !containEdit;

  const onChangeFile = (e) => {
    const files = e.target.files;
    if (!files || files.length <= 0) return;
    const file = files?.[0];
    if (!file) return;
    Object.assign(file, { preview: URL.createObjectURL(file) });
    setFieldValue(name, file);
  };

  const onRemoveFile = () => {
    setFieldValue(name, "");
  };
  return (
    <Box>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {label}
        </SoftTypography>
      </SoftBox>
      <Box
        maxWidth="100%"
        border={`1px solid ${
          !disabled
            ? !error
              ? success && !containEdit
                ? "#66d432"
                : "#d2d6da"
              : "#fd5c70"
            : "#d2d6da"
        }`}
        padding="10px"
        borderRadius="6px"
        position="relative"
      >
        <input
          onChange={onChangeFile}
          type="file"
          id={name}
          multiple={false}
          accept="image/*"
          style={{ display: "none" }}
          disabled={disabled}
          onBlur={onBlur}
          name={name}
        />
        <label
          htmlFor={name}
          style={{
            cursor: disabled ? "none" : "pointer",
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          <span
            style={{
              minHeight: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              title="Ảnh preview"
              src={file?.preview ?? "/upload.png"}
              alt={name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </span>
        </label>
        {file && Object.keys(file).length && !disabled && (
          <Box
            position="absolute"
            top={-15}
            right={-15}
            backgroundColor="#e4e7eb"
            borderRadius={100}
            display="flex"
            justifyContent="center"
            alignItems="center"
            title="Xóa file"
            onClick={onRemoveFile}
          >
            <IconButton size="small" aria-label="close" color="inherit">
              <Icon fontSize="small">close</Icon>
            </IconButton>
          </Box>
        )}
      </Box>
      <SoftBox mt={0.75}>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </Box>
  );
}
